import React, { useState, useRef } from "react";
import { useDispatch } from "react-redux";
import { Box, Grid, useTheme, useMediaQuery } from "@mui/material";

import { setSelectedPlan } from "../coverageSlice";
import { postPackage } from "../coverageSlice";

import { nextStep } from "../../quote/quoteSlice";

import CoverageCard from "./CoverageCard";

const CoverageCarousel = ({ plans }) => {
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up("md"));
  const carouselRef = useRef(null);

  const [activeStep, setActiveStep] = useState(0);
  const [touchStart, setTouchStart] = useState(null);
  const [touchEnd, setTouchEnd] = useState(null);

  const minSwipeDistance = 50;

  const dispatch = useDispatch();

  const handleSelectPlan = (plan) => {

    dispatch(setSelectedPlan(plan));

    const result = dispatch(postPackage({ packageId: plan.package_id })).unwrap();

    if (result) {
      dispatch(nextStep());
    }
  };

  const handleTouchStart = (e) => {
    setTouchStart(e.targetTouches[0].clientX);
    setTouchEnd(null);
  };

  const handleTouchMove = (e) => {
    setTouchEnd(e.targetTouches[0].clientX);
  };

  const handleTouchEnd = () => {
    if (!touchStart || !touchEnd) return;

    const distance = touchStart - touchEnd;

    if (distance > minSwipeDistance) {
      setActiveStep((prev) => Math.min(prev + 1, plans.length - 1));
    } else if (distance < -minSwipeDistance) {
      setActiveStep((prev) => Math.max(prev - 1, 0));
    }

    setTouchStart(null);
    setTouchEnd(null);
  };

  if (!plans || plans.length === 0) {
    return <Box sx={{ textAlign: "center", py: 4 }}>No hay planes disponibles</Box>;
  }

  if (isDesktop) {
    return (
      <Box sx={{ maxWidth: "100%", mx: "auto", px: 2 }}>
        <Grid container spacing={3} justifyContent="center">
          {plans.map((plan) => (
            <Grid key={`${plan.package_id || Math.random()}`} size={{ xs: 12, sm: 6, md: 4 }} 
              sx={{ 
                display: "flex", 
                justifyContent: "center" 
              }}>
              <CoverageCard 
                title={plan.title} 
                features={plan.features || []} 
                price={plan.price}
                onSelect={() => handleSelectPlan(plan)}
              />
            </Grid>
          ))}
        </Grid>
      </Box>
    );
  }

  return (
    <Box
      ref={carouselRef}
      sx={{
        maxWidth: 400,
        margin: "auto",
        overflow: "hidden",
        touchAction: "pan-y",
      }}
      onTouchStart={handleTouchStart}
      onTouchMove={handleTouchMove}
      onTouchEnd={handleTouchEnd}
    >
      <Box
        sx={{
          display: "flex",
          transition: "transform 0.3s ease",
          transform: `translateX(-${activeStep * 100}%)`,
        }}
      >
        {plans.map((plan) => (
          <Box key={`${plan.package_id || Math.random()}`} sx={{ minWidth: "100%", px: 1 }}>
            <CoverageCard 
              title={plan.title} 
              features={plan.features || []} 
              price={plan.price}
              onSelect={() => handleSelectPlan(plan)}
            />
          </Box>
        ))}
      </Box>
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          mt: 2,
          gap: 1,
        }}
      >
        {plans.map((_, index) => (
          <Box
            key={index}
            onClick={() => setActiveStep(index)}
            sx={{
              width: activeStep === index ? 10 : 8,
              height: activeStep === index ? 10 : 8,
              borderRadius: "50%",
              bgcolor: activeStep === index ? "#181818" : "grey.400",
              cursor: "pointer",
              transition: "all 0.2s ease",
            }}
          />
        ))}
      </Box>
    </Box>
  );
};

export default CoverageCarousel;
